// Build-time mirrors of backend feature flags. Each one is off unless the
// matching REACT_APP_* variable is exactly "true"; keep them in step with the
// backend flag of the same name (backend/.env.example).

// FEATURE_WORKSPACES (#170): team workspaces are hidden; every user has one
// personal workspace. Do not enable until the owner-escalation hole, the
// last-owner guard and invite management are fixed (#171).
export const WORKSPACES_ENABLED = process.env.REACT_APP_FEATURE_WORKSPACES === "true";
